module.exports = __webpack_public_path__ + "static/img_reciclaje-a187a6eca2e5b720b1e30e2697b158e9.webp";